import type { ReactNode } from 'react'
import { useAsyncAction } from '../hooks/useAsyncAction'

interface AsyncButtonProps {
  onClick: () => unknown | Promise<unknown>; children: ReactNode; pendingText?: string; disabled?: boolean; className?: string; progress?: boolean; 'aria-label'?: string
}
export function AsyncButton(props: AsyncButtonProps) {
  const action = useAsyncAction()
  return <ActionButtonView {...props} pending={action.pending} error={action.error} onClick={() => { void action.run(async () => props.onClick()) }} />
}
export function ActionButtonView({ onClick, children, pendingText = 'Procesando…', disabled, className, progress = false, 'aria-label': label, pending, error }: AsyncButtonProps & { pending: boolean; error?: unknown }) {
  return <><button type="button" className={className} aria-label={label} aria-busy={pending} disabled={disabled || pending} onClick={onClick}>{pending ? pendingText : children}</button>{pending && progress && <IndeterminateProgress />}{error !== undefined && <span className="notice notice--error" role="alert">{error instanceof Error ? error.message : 'No se pudo completar la operación.'}</span>}</>
}
export function IndeterminateProgress() { return <progress aria-label="Operación en curso" /> }
